import React, { useEffect, useState } from "react";
import { APP_CONST, gameTypes as types } from "../../../../config/const";
import AppDropDown from "../../../components/AppDropDown";
import { casinoGamesList } from "../../../../lib/data/casinoGames.data";
import CasinoCard from "../../../components/CasinoCard";
import { useNavigate } from "react-router-dom";
import LeftArrow from "../../../../assets/images/icons/back.png";
import SearchIcon from "../../../../assets/images/icons/search.png";
import LeftBarSports from "../../../components/LeftBarSports";
import ModalWrapper from "../../../../containers/ModalWrapper";
import Footer from "../../../../containers/Footer";
const ALL_TYPE = {
  name: "All",
  key: "all",
};

const GAME_PROVIDERS = [
  {
    id: 0,
    name: "Select Provider",
    key: null,
  },
  {
    id: 0,
    name: "Ezugi",
    key: "ezugi",
  },
  {
    id: 1,
    name: "Evolution",
    key: "evolution",
  },
  {
    id: 2,
    name: "NetEnt",
    key: "netent",
  },
  {
    id: 3,
    name: "RedTiger",
    key: "redtiger",
  },
  {
    id: 4,
    name: "Vivo",
    key: "vivo",
  },
  {
    id: 5,
    name: "Aura",
    key: "aura",
  },
  {
    id: 6,
    name: "Spribe",
    key: "spribe",
  },
  {
    id: 7,
    name: "Kingmaker",
    key: "kingmaker",
  },
  // {
  //   id: 8,
  //   name: "Qtech",
  //   key: "qtech",
  // },
  // {{}
  //   id: 9,
  //   name: "Venum",
  //   key: "venum",
  // },
];

const GAME_CATEGORIES = [
  {
    id: 0,
    name: "Select Category",
    key: null,
  },
  {
    id: 0,
    name: "Roulette",
    key: "roulette",
  },
  {
    id: 1,
    name: "Andarbahar",
    key: "andarbahar",
  },
  {
    id: 2,
    name: "Livecasino",
    key: "livecasino",
  },
  {
    id: 3,
    name: "Baccarat",
    key: "baccarat",
  },
  {
    id: 4,
    name: "Blackjack",
    key: "blackjack",
  },
  {
    id: 5,
    name: "Crash",
    key: "crash",
  },
  {
    id: 6,
    name: "Slots",
    key: "slots",
  },
];

const GAME_TYPES = [
  { id: 0, name: ALL_TYPE.name, key: ALL_TYPE.key },
  {
    id: 1,
    name: "New",
    key: types.new,
  },
  {
    id: 2,
    name: "Popular",
    key: types.popular,
  },
];

const FILTER_TYPES = {
  gameType: "gameType",
  provider: "provider",
  category: "category",
  search: "search",
};

const CasinoGamesListing = () => {
  const navigate = useNavigate();
  const [defaultModal, setDefaultModal] = useState(APP_CONST.AUTH_MODAL.LOGIN);
  const [activeFilters, setActiveFilters] = useState({
    gameType: GAME_TYPES[0],
    provider: null,
    category: null,
    search: null,
  });
  const [gamesList, setGamesList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showAuthModals, setShowAuthModals] = useState(false);
  const handleModalShow = (modalName) => {
    setShowAuthModals(true);

    setDefaultModal(modalName);
  };
  const handleFilterChange = (value, filterType) => {
    setActiveFilters((p) => ({
      ...p,
      [FILTER_TYPES[filterType]]:
        Boolean(value?.key) || filterType === FILTER_TYPES.search
          ? value
          : null,
    }));
  };

  useEffect(() => {
    const iterableData = createIterableData(casinoGamesList);
    const filteredData = filterGames(activeFilters, iterableData);
    setGamesList(filteredData);
  }, [activeFilters, casinoGamesList]);

  /**
   *
   * @param {Object} object
   * @returns {Array}
   */
  const createIterableData = (object) => {
    let tempArray = [];
    Object.values(object).map((games) => {
      Object.values(games).map((game) => {
        tempArray.push(game);
      });
    });
    return tempArray;
  };

  const filterGames = (filters, dataToFilter = []) => {
    const filterValues = dataToFilter.filter((f) => {
      return (
        (filters?.gameType?.key === ALL_TYPE.key ||
          (f?.gameType && f?.gameType === filters.gameType.key)) &&
        (!Boolean(filters?.provider) ||
          f.provider?.toLowerCase() ===
            filters?.provider?.key?.toLowerCase()) &&
        (!Boolean(filters?.category) ||
          f.category?.toLowerCase() === filters?.category?.key) &&
        (!Boolean(filters?.search) ||
          f?.name?.toLowerCase()?.indexOf(filters?.search?.toLowerCase()) > -1)
      );
    });
    return filterValues;
  };

  return (
    <>
      <main className="main">
        <div className="main-page">
          <LeftBarSports />

          <div className="main-content">
            <div className="container-fluid">
              <div className="headingSec">
                <div className="back-link" onClick={() => navigate(-1)}>
                  <img src={LeftArrow} alt="LeftArrow" /> <h1>Casino</h1>
                </div>
              </div>

              <div className="CasinoPageSection">
                <ul className="CasinoPageTabsSection">
                  {GAME_TYPES.map((type, idx) => (
                    <li
                      key={idx}
                      onClick={() =>
                        handleFilterChange(type, FILTER_TYPES.gameType)
                      }
                      className={
                        activeFilters[FILTER_TYPES.gameType]?.key === type.key
                          ? "active"
                          : ""
                      }
                    >
                      {type.name}
                    </li>
                  ))}
                </ul>
                <div className="Provider-CategoryTabs">
                  <div className="ProviderTabs">
                    <AppDropDown
                      menuItems={GAME_PROVIDERS}
                      name={
                        activeFilters[FILTER_TYPES.provider]?.name || "Provider"
                      }
                      onSelect={(value) =>
                        handleFilterChange(value, FILTER_TYPES.provider)
                      }
                    />
                  </div>

                  <div className="ProviderTabs">
                    <AppDropDown
                      menuItems={GAME_CATEGORIES}
                      name={
                        activeFilters[FILTER_TYPES.category]?.name || "Category"
                      }
                      onSelect={(value) =>
                        handleFilterChange(value, FILTER_TYPES.category)
                      }
                    />
                  </div>
                </div>
                <div className="searchTabs">
                  <input
                    placeholder="search"
                    onChange={(e) =>
                      handleFilterChange(e.target.value, FILTER_TYPES.search)
                    }
                  />
                  <button>
                    <img src={SearchIcon} alt="SearchIcon" />
                  </button>
                </div>
              </div>
              <div className="GamesSection">
                {gamesList?.length ? (
                  gamesList?.map((game, idx) => {
                    return (
                      <CasinoCard
                        data={game}
                        imageUrlCheck={true}
                        index={idx}
                        setShowAuthModals={setShowAuthModals}
                      />
                    );
                  })
                ) : (
                  <p>No data found</p>
                )}
              </div>
            </div>

            <Footer />
          </div>
        </div>
        {showAuthModals && (
          <ModalWrapper
            defaultShow={defaultModal}
            handleClose={setShowAuthModals}
          />
        )}
      </main>
    </>
  );
};
export default CasinoGamesListing;
